export default __webpack_public_path__ + "static/media/digital-margeting.1b48047a.png";